import { jsx as _jsx } from "react/jsx-runtime";
import { App, Form, Modal } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { LicenseKeyAddEditForm } from "./licenseKeyAddEditForm.js";
import { useStores } from "../../../../../../store/stores.js";
import { __ } from "../../../../../../utils/i18n.js";
import { useFormDirtyGuard } from "../../../../hooks/useFormDirtyGuard.js";
const LicenseKeyModal = observer(({ subscription, license, open, onClose })=>{
    const { accountV2Store } = useStores();
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [isBusy, setIsBusy] = useState(false);
    const isEdit = !!license;
    const guardedCancel = useFormDirtyGuard(form, onClose, {
        title: isEdit ? __("Discard unsaved changes?") : __("Discard the new license key?"),
        body: isEdit ? __("You've changed this license key but haven't saved yet. Closing now will discard your edits.") : __("Your license key hasn't been created yet. Closing now will discard what you've entered."),
        okText: isEdit ? __("Discard changes") : __("Discard"),
        cancelText: __("Keep editing")
    });
    // After a successful create: flash the newly-added row in the list,
    // auto-copy the license key to the customer's clipboard and confirm
    // both in a single toast. Clipboard can fail silently (insecure context,
    // permission denied) — the toast text degrades to the no-copy variant.
    const handleCreated = async (created)=>{
        accountV2Store.flashLicense(created.data.id);
        let copied = false;
        if (typeof navigator !== "undefined" && navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(created.data.licenseKey);
                copied = true;
            } catch  {
            // ignore — fall through to no-copy success toast
            }
        }
        message.success(copied ? __("License key created and copied to clipboard.") : __("License key created - find it in the License keys section."));
    };
    return /*#__PURE__*/ _jsx(Modal, {
        open: open,
        title: isEdit ? __("Edit license key") : __("Create license key"),
        footer: null,
        onCancel: isBusy ? undefined : guardedCancel,
        maskClosable: !isBusy,
        destroyOnClose: true,
        width: 640,
        children: /*#__PURE__*/ _jsx(LicenseKeyAddEditForm, {
            subscription: subscription,
            license: license,
            mode: isEdit ? "edit" : "add",
            onCreated: handleCreated,
            onDone: onClose,
            form: form,
            onBusyChange: setIsBusy
        })
    });
});
export { LicenseKeyModal };
